import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6bddb034")

_pushScopeId("data-v-6bddb034")
const _hoisted_1 = {
  key: 0,
  class: "loader-container"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("dig-ui-loader", null, null, -1)
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "no-data-container"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "ctrl-buttons" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "center title-1" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "center title-1" }
const _hoisted_11 = /*#__PURE__*/_createVNode("dig-ui-title", { class: "center title-1" }, " Dossiers de l'utilisateur ", -1)
const _hoisted_12 = {
  key: 0,
  class: "loader-container"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("dig-ui-loader", null, null, -1)
const _hoisted_14 = {
  key: 1,
  class: "dossiers"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_user_display = _resolveComponent("user-display")
  const _component_user_form = _resolveComponent("user-form")
  const _component_base_card = _resolveComponent("base-card")
  const _component_simulations_search = _resolveComponent("simulations-search")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_base_card, { class: "main-card" }, {
      default: _withId(() => [
        ($setup.loadingUser)
          ? (_openBlock(), _createBlock("div", _hoisted_1, [
              _hoisted_2
            ]))
          : _createCommentVNode("", true),
        (!$setup.loadingUser)
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              (!$setup.storeUser.getters[$setup.StoreGettersUser.HAS_USER])
                ? (_openBlock(), _createBlock("div", _hoisted_4, _toDisplayString($setup.t('noDataUser')), 1))
                : _createCommentVNode("", true),
              ($setup.storeUser.getters[$setup.StoreGettersUser.HAS_USER])
                ? (_openBlock(), _createBlock("div", _hoisted_5, [
                    _createVNode("div", _hoisted_6, [
                      ($setup.isAdmin && !$setup.editing)
                        ? (_openBlock(), _createBlock("dig-ui-delete-button", {
                            key: 0,
                            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.deleteUser())),
                            class: "icon-button"
                          }))
                        : _createCommentVNode("", true),
                      ($setup.isAdmin && !$setup.editing)
                        ? (_openBlock(), _createBlock("dig-ui-edit-button", {
                            key: 1,
                            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleEditing())),
                            class: "icon-button"
                          }))
                        : _createCommentVNode("", true),
                      ($setup.isAdmin && $setup.editing)
                        ? (_openBlock(), _createBlock("dig-ui-close-button", {
                            key: 2,
                            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.toggleEditing())),
                            class: "icon-button"
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    (!$setup.editing)
                      ? (_openBlock(), _createBlock("div", _hoisted_7, [
                          _createVNode("dig-ui-title", _hoisted_8, _toDisplayString($setup.t('user')) + " " + _toDisplayString($setup.storeUser.getters[$setup.StoreGettersUser.USER].username), 1),
                          _createVNode(_component_user_display, {
                            user: $setup.storeUser.getters[$setup.StoreGettersUser.USER]
                          }, null, 8, ["user"])
                        ]))
                      : _createCommentVNode("", true),
                    ($setup.editing)
                      ? (_openBlock(), _createBlock("div", _hoisted_9, [
                          _createVNode("dig-ui-title", _hoisted_10, _toDisplayString($setup.t('editUser')), 1),
                          _createVNode(_component_user_form, {
                            user: $setup.storeUser.getters[$setup.StoreGettersUser.USER],
                            loading: $setup.loadingForm,
                            onValidate: _cache[4] || (_cache[4] = ($event: any) => ($setup.updateUser($event))),
                            onCancel: _cache[5] || (_cache[5] = ($event: any) => ($setup.toggleEditing()))
                          }, null, 8, ["user", "loading"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode("div", null, [
      _hoisted_11,
      ($setup.loadingSimulation || !$setup.userId)
        ? (_openBlock(), _createBlock("div", _hoisted_12, [
            _hoisted_13
          ]))
        : _createCommentVNode("", true),
      (!$setup.loadingSimulation && $setup.userId)
        ? (_openBlock(), _createBlock("div", _hoisted_14, [
            _createVNode(_component_simulations_search, {
              simulations: 
          $setup.storeSimulation.getters[$setup.StoreGettersSimulation.SIMULATIONS].filter(
            s => s.userId === $setup.userId,
          )
        
            }, null, 8, ["simulations"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
})